import { showLog } from "./log";

export default function formatPhone(params) {
  showLog("FormatPhone Masuk formatPhone");
  return params?.replace("+62", "");
}
